/* eslint-disable */
// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, useQuery } from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  getIsoCountryCodes,
  getProductActivityByCountry,
  getProductLastSessionSummary,
  getProductLocations,
  getProductTypeByCountry,
  getSingleLocation,
  type Options,
} from '../sdk.gen';
import type {
  GetIsoCountryCodesData,
  GetIsoCountryCodesError,
  GetIsoCountryCodesResponse,
  GetProductActivityByCountryData,
  GetProductActivityByCountryError,
  GetProductActivityByCountryResponse,
  GetProductLastSessionSummaryData,
  GetProductLastSessionSummaryError,
  GetProductLastSessionSummaryResponse,
  GetProductLocationsData,
  GetProductLocationsError,
  GetProductLocationsResponse,
  GetProductTypeByCountryData,
  GetProductTypeByCountryError,
  GetProductTypeByCountryResponse,
  GetSingleLocationData,
  GetSingleLocationError,
  GetSingleLocationResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getProductActivityByCountryQueryKey = (
  options: Options<GetProductActivityByCountryData>,
) => createQueryKey('getProductActivityByCountry', options, false, ['Analytics']);

export const getProductActivityByCountryOptions = (
  options: Options<GetProductActivityByCountryData>,
) =>
  queryOptions<
    GetProductActivityByCountryResponse,
    GetProductActivityByCountryError,
    GetProductActivityByCountryResponse,
    ReturnType<typeof getProductActivityByCountryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProductActivityByCountry({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProductActivityByCountryQueryKey(options),
  });

export const useGetProductActivityByCountryQuery = (
  options: Options<GetProductActivityByCountryData>,
) => useQuery(getProductActivityByCountryOptions(options));

export const getProductLastSessionSummaryQueryKey = (
  options: Options<GetProductLastSessionSummaryData>,
) => createQueryKey('getProductLastSessionSummary', options, false, ['Analytics']);

export const getProductLastSessionSummaryOptions = (
  options: Options<GetProductLastSessionSummaryData>,
) =>
  queryOptions<
    GetProductLastSessionSummaryResponse,
    GetProductLastSessionSummaryError,
    GetProductLastSessionSummaryResponse,
    ReturnType<typeof getProductLastSessionSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProductLastSessionSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProductLastSessionSummaryQueryKey(options),
  });

export const useGetProductLastSessionSummaryQuery = (
  options: Options<GetProductLastSessionSummaryData>,
) => useQuery(getProductLastSessionSummaryOptions(options));

export const getProductTypeByCountryQueryKey = (options: Options<GetProductTypeByCountryData>) =>
  createQueryKey('getProductTypeByCountry', options, false, ['Analytics']);

export const getProductTypeByCountryOptions = (options: Options<GetProductTypeByCountryData>) =>
  queryOptions<
    GetProductTypeByCountryResponse,
    GetProductTypeByCountryError,
    GetProductTypeByCountryResponse,
    ReturnType<typeof getProductTypeByCountryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProductTypeByCountry({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProductTypeByCountryQueryKey(options),
  });

export const useGetProductTypeByCountryQuery = (options: Options<GetProductTypeByCountryData>) =>
  useQuery(getProductTypeByCountryOptions(options));

export const getProductLocationsQueryKey = (options: Options<GetProductLocationsData>) =>
  createQueryKey('getProductLocations', options, false, ['Locations']);

export const getProductLocationsOptions = (options: Options<GetProductLocationsData>) =>
  queryOptions<
    GetProductLocationsResponse,
    GetProductLocationsError,
    GetProductLocationsResponse,
    ReturnType<typeof getProductLocationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProductLocations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProductLocationsQueryKey(options),
  });

export const useGetProductLocationsQuery = (options: Options<GetProductLocationsData>) =>
  useQuery(getProductLocationsOptions(options));

export const getSingleLocationQueryKey = (options: Options<GetSingleLocationData>) =>
  createQueryKey('getSingleLocation', options, false, ['Locations']);

export const getSingleLocationOptions = (options: Options<GetSingleLocationData>) =>
  queryOptions<
    GetSingleLocationResponse,
    GetSingleLocationError,
    GetSingleLocationResponse,
    ReturnType<typeof getSingleLocationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSingleLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSingleLocationQueryKey(options),
  });

export const useGetSingleLocationQuery = (options: Options<GetSingleLocationData>) =>
  useQuery(getSingleLocationOptions(options));

export const getIsoCountryCodesQueryKey = (options?: Options<GetIsoCountryCodesData>) =>
  createQueryKey('getIsoCountryCodes', options, false, ['Product Location Activity/Meta Data']);

export const getIsoCountryCodesOptions = (options?: Options<GetIsoCountryCodesData>) =>
  queryOptions<
    GetIsoCountryCodesResponse,
    GetIsoCountryCodesError,
    GetIsoCountryCodesResponse,
    ReturnType<typeof getIsoCountryCodesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getIsoCountryCodes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getIsoCountryCodesQueryKey(options),
  });

export const useGetIsoCountryCodesQuery = (options?: Options<GetIsoCountryCodesData>) =>
  useQuery(getIsoCountryCodesOptions(options));
